import { queryOptions } from '@tanstack/react-query';
import { getTenantSetting } from './api';

export const tenantSettingsQueryKeys = {
  all: () => ['tenant-settings'],
  details: () => [...tenantSettingsQueryKeys.all(), 'detail'],
  detail: (tenantId: string, id?: number) =>
    queryOptions({
      queryKey: [...tenantSettingsQueryKeys.details(), tenantId],
      queryFn: () => getTenantSetting(tenantId),
      enabled: id !== undefined,
    }),
  updateMutation: () => [...tenantSettingsQueryKeys.all(), 'update'] as const,
};
